// extracted by mini-css-extract-plugin
export var avatarContainer = "_1c-0";
export var avatarTypingWave = "_1c-i";
export var gray = "_1c-f";
export var green = "_1c-c";
export var icon = "_1c-9";
export var image = "_1c-1";
export var lg = "_1c-6";
export var md = "_1c-5";
export var presenceDot = "_1c-b";
export var red = "_1c-d";
export var sm = "_1c-4";
export var status = "_1c-a";
export var typingDot = "_1c-h";
export var typingPill = "_1c-g";
export var xl = "_1c-7";
export var xs = "_1c-3";
export var xxl = "_1c-8";
export var xxs = "_1c-2";
export var yellow = "_1c-e";